export const printContent = (contentToPrint) => {
  const secondaryWindow = window.open("", "_blank", "width=600,height=600");
  secondaryWindow.document.open();
  secondaryWindow.document.write(contentToPrint);
  secondaryWindow.document.title = document.title;
  secondaryWindow.print();
};
